import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const LegalLayout = ({ eyebrow, title, children, testId }) => {
  const { t } = useLanguage();
  return (
    <main data-testid={testId} className="pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-10">
        <span className="text-xs font-bold tracking-[0.2em] uppercase text-amber-600">
          {eyebrow}
        </span>
        <h1 className="mt-3 text-4xl sm:text-5xl font-black tracking-tighter text-blue-950 leading-[1.05]">
          {title}
        </h1>
        <p className="mt-3 text-sm text-slate-500">{t.legal.lastUpdated}</p>

        <article className="mt-10 space-y-7 text-[15px] sm:text-base text-slate-700 leading-relaxed">
          {children}
        </article>
      </div>
    </main>
  );
};

export const Section = ({ title, children }) => (
  <section>
    <h2 className="text-xl sm:text-2xl font-bold text-blue-950 tracking-tight mb-3">
      {title}
    </h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export default LegalLayout;
